import { UIGameMapTileEdgeHighlightController } from '../ui_game_map_highlight/UIGameMapTileEdgeHighlightController.ts';
import { GameStateEnums } from '../../../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { UIGameMapHighlightView } from '../UIGameMapHighlightView.ts';
import { PIXI } from '@colonist/pixi';
import { GameAction } from '@colonist/game-base-types';
import { ArrayUtils } from '@colonist/utils';
export class UIGameMapTileEdgeHoverController extends UIGameMapTileEdgeHighlightController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.GameEnd:
                this.removeHighlights();
                break;
            case UIGameEventEnums.BeginnerHintReceived:
                this.beginnerHintReceived(data);
                break;
            case UIGameEventEnums.GameStateUpdated:
                this.destroyBeginnerHintView();
                break;
            case UIGameEventEnums.CanvasResized:
                this.onCanvasResize();
                break;
            case UIGameEventEnums.BeginnerModeActionUpdated:
                this.onBeginnerModeActionUpdate(data);
                break;
            default:
                break;
        }
    }
    registerHoverAction(hoverAction) {
        this.hoverMechanicActions.push(hoverAction);
    }
    onHoverStateChange(isHoverStateActive) {
        const beginnerHintActive = this.beginnerHintView != undefined;
        if (beginnerHintActive) {
            this.destroyBeginnerHintView();
            this.beginnerHintReceived(this.beginnerHint);
        }
        if (!isHoverStateActive) {
            this.removeHighlights();
            return;
        }
        const previousRoadEdges = [
            ...this.roadEdges
        ];
        const previousShipEdges = [
            ...this.shipEdges
        ];
        const selectedIndex = this.confirmActionController.selectedLocationIndex;
        this.updateRoadAndShipEdges();
        const wasEmpty = this.highlightViews.length === 0;
        const hasEdges = this.roadEdges.length > 0 || this.shipEdges.length > 0;
        if (wasEmpty && hasEdges) {
            this.updateHighlightsDifferentially([], [], selectedIndex);
        } else if (this.hasEdgeChanges(previousRoadEdges, previousShipEdges)) {
            this.updateHighlightsDifferentially(previousRoadEdges, previousShipEdges, selectedIndex);
        } else if (hasEdges) {
            this.confirmActionController.setupInvisibleBackground(()=>{
                this.startAnimation();
                this.hideBeginnerHintInformation();
            });
        }
        this.updateHighlightVisibility();
    }
    onHoverHighlightClick() {
        this.onHoverStateChange(true);
        this.endAnimation();
    }
    onHoverHighlightCancellation() {
        this.startAnimation();
    }
    onClickInvisibleBackground() {
        this.confirmActionController.cleanupConfirmation();
    }
    highlight(highlightParameters, action) {
        const highlightView = new UIGameMapHighlightView(this.uiGameManager, highlightParameters, this.uiGameManager.mapController.mapView, action, false, this.shouldHighlightOnlyOnHover);
        if (this.shouldHighlightOnlyOnHover) {
            highlightView.displayOnlyOnHover();
        } else {
            const canAffordAction = this.getMechanicsAssociatedWithEdge(highlightParameters.index).some((mechanic)=>mechanic.canTakeAction);
            highlightView.displayAlwaysOn(canAffordAction);
        }
        this.highlightViews.push(highlightView);
    }
    updateRoadAndShipEdges() {
        const newRoadEdges = [];
        const newShipEdges = [];
        this.hoverMechanicActions.forEach((mechanicAction)=>{
            if (mechanicAction.isCornerAction) return;
            if (mechanicAction.isShipAction) newShipEdges.push(...mechanicAction.validLocations);
            else newRoadEdges.push(...mechanicAction.validLocations);
        });
        this.roadEdges = newRoadEdges;
        this.shipEdges = newShipEdges;
    }
    getActionForEdgeHighlight(highlightParameters, index) {
        return ()=>{
            var _this_currentBeginnerModeAction, _this_currentBeginnerModeAction1;
            if (this.currentBeginnerModeAction) this.currentBeginnerModeAction.guideText.options = {
                ...(_this_currentBeginnerModeAction = this.currentBeginnerModeAction) === null || _this_currentBeginnerModeAction === void 0 ? void 0 : _this_currentBeginnerModeAction.guideText.options,
                context: 'WantToBuildRoad'
            };
            if (!this.isAllowedPlacementIndex(index)) return this.uiGameManager.eventController.sendEvent((_this_currentBeginnerModeAction1 = this.currentBeginnerModeAction) === null || _this_currentBeginnerModeAction1 === void 0 ? void 0 : _this_currentBeginnerModeAction1.guideText, GameStateEnums.UIGameEventEnums.BeginnerModeForceOpenGuideBubble);
            this.uiGameManager.mapController.hoverController.onClickInvisibleBackground();
            this.destroyBeginnerHintView();
            const buttonSize = highlightParameters.size * 1.75 * this.buttonScaleForMobile;
            const highlightCenter = new PIXI.Point(highlightParameters.x + highlightParameters.size / 2, highlightParameters.y + highlightParameters.size / 2);
            const buttonX = highlightCenter.x - buttonSize / 2;
            const buttonY = highlightCenter.y - buttonSize * 1.5;
            this.uiGameManager.mapController.hoverController.onHoverHighlightClick();
            const cancelAction = ()=>{
                this.uiGameManager.mapController.hoverController.onHoverHighlightCancellation();
            };
            const mechanicsAssociatedWithEdge = this.getMechanicsAssociatedWithEdge(index);
            const confirmationParameters = [];
            mechanicsAssociatedWithEdge.forEach((mechanic)=>confirmationParameters.push(mechanic.getConfirmationParameters(index)));
            this.confirmActionController.showActionConfirmation(highlightParameters, buttonX, buttonY, buttonSize, cancelAction, confirmationParameters, index);
        };
    }
    beginnerHintReceived(data) {
        if (data.type != GameAction.ConfirmBuildRoad) return;
        super.beginnerHintReceived(data);
    }
    getMechanicsAssociatedWithEdge(index) {
        const allowedMechanics = [];
        for (const mechanic of this.hoverMechanicActions){
            if (mechanic.isCornerAction) continue;
            if (mechanic.validLocations.includes(index)) allowedMechanics.push(mechanic);
        }
        return allowedMechanics;
    }
    updateHighlightVisibility() {
        if (this.shouldHighlightOnlyOnHover) return;
        for (const highlightView of this.highlightViews){
            const canAffordAction = this.getMechanicsAssociatedWithEdge(highlightView.highlightedGameElementIndex).some((mechanic)=>mechanic.canTakeAction);
            highlightView.displayAlwaysOn(canAffordAction);
        }
    }
    hasEdgeChanges(previousRoadEdges, previousShipEdges) {
        const roadChanges = ArrayUtils.arraysEqual(previousRoadEdges.sort(), this.roadEdges.sort());
        const shipChanges = ArrayUtils.arraysEqual(previousShipEdges.sort(), this.shipEdges.sort());
        const roadChanged = previousRoadEdges.length !== this.roadEdges.length || !roadChanges;
        const shipChanged = previousShipEdges.length !== this.shipEdges.length || !shipChanges;
        return roadChanged || shipChanged;
    }
    constructor(uiGameManager, shouldHighlightOnlyOnHover){
        super(uiGameManager);
        this.shouldHighlightOnlyOnHover = shouldHighlightOnlyOnHover;
        this.hoverMechanicActions = [];
    }
}
